export enum TitleBarType {
  Main = 'Main',
  Landing = 'Landing',
  Sub = 'Sub',
  Helix = 'Helix',
}
